<template>
  <back-office-form
    :inputs="inputs"
    :item="bridge"
    :delete-button-label="this.$t('bridges.delete')"
    delete-confirmation-attribute="name"
    :mode="mode"
    :modes="modes"
    @submit="handleSubmit"
    @delete="handleDelete"
  />
</template>

<script>
  import BackOfficeForm from '@/components/BackOfficeForm'
  import BridgeProperties from './BridgeProperties'

  export default {
    name: 'BridgeForm',
    components: { BackOfficeForm },
    props: {
      bridge: {
        type: Object,
        default: () => {
          return {}
        }
      },
      mode: {
        type: String,
        required: true
      }
    },
    methods: {
      handleSubmit (...rest) {
        this.$emit('submit', ...rest)
      },
      handleDelete () {
        this.$emit('delete')
      }
    },
    computed: {
      modes () {
        return {
          create: {
            title: 'bridges.add',
            subtitles: ['bridges.addDescription']
          },
          edit: {
            title: 'bridges.edit',
            subtitles: ['']
          }
        }
      },
      inputs () {
        return [
          {
            name: 'name',
            validators: 'required',
            properties: {
              placeholder: this.$t('bridges.newBridgePlaceholder'),
              label: this.$t('common.name')
            }

          },
          {
            name: 'routerUrl',
            validators: 'required',
            properties: {
              placeholder: this.$t('bridges.routerUrlPlaceholder'),
              label: this.$t('bridges.routerUrl')
            }
          },
          {
            name: 'properties',
            is: BridgeProperties,
            properties: {
              label: this.$t('common.properties'),
            }
          },
        ]
      }
    }
  }
</script>

<style scoped>
</style>
